import { FC, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';

import ProgressBar from '~src/shared/ProgressBar';

interface Props {
  progress: number;
}

const ProgressText = styled.span.attrs({ className: 'hl3' })`
  margin-bottom: 5px;
`;

const Wrapper = styled.div`
  margin-top: 30px;
  padding-left: 35px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ProgressIndicator: FC<Props> = props => {
  const [t] = useTranslation();
  const themeContext = useContext(ThemeContext);

  const progressColor = { 29: themeContext.gold.a10, 69: themeContext.green.a10 };
  return (
    <Wrapper>
      <ProgressText data-translation="x.okrs.progress.indicator">
        {t('x.okrs.progress.indicator', { progress: props.progress })}
      </ProgressText>
      <ProgressBar
        height={5}
        width="100%"
        staticProgress
        progress={props.progress}
        progressColor={progressColor}
      />
    </Wrapper>
  );
};

export default ProgressIndicator;
